import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'
import type { CrmPageProps } from '@/lib/crm-page'

import AppShell from '@/components/generals/app-shell'
import Companies from '@/components/companies/companies'
import { loadCrmPageProps } from '@/lib/crm-page'

const Home: FC<Partial<CrmPageProps>> = ({ data, today }): ReactNode => {
    return (
        <AppShell data={data} today={today ?? ''}>
            <Companies />
        </AppShell>
    )
}

export const getServerSideProps: GetServerSideProps<CrmPageProps> = async () => {
    return { props: await loadCrmPageProps() }
}

export default Home
